import PasswordRecoveryEmailSentPage from "./PasswordRecoveryEmailSentPage";

export default PasswordRecoveryEmailSentPage;
